module.exports = __webpack_public_path__ + "images/c5979aaca513becc68c84207fe5355d6.woff";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/syrcomkharput.woff
// module id = 1151
// module chunks = 0